import { render, staticRenderFns } from "./SellableTimeSlots.vue?vue&type=template&id=23c1cdf6"
import script from "./SellableTimeSlots.vue?vue&type=script&lang=ts"
export * from "./SellableTimeSlots.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports